'use client'

import { Phone } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

interface TwilioConnectionBannerProps {
  canConnect: boolean
  onConnect: () => void
}

export function TwilioConnectionBanner({
  canConnect,
  onConnect,
}: TwilioConnectionBannerProps) {
  return (
    <Alert className="border-blue-200 bg-blue-50 text-blue-950">
      <Phone className="h-4 w-4 text-blue-700" />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <AlertTitle>Connect Twilio when you&apos;re ready</AlertTitle>
          <AlertDescription className="mt-1 text-blue-800">
            You can add and use external SIP numbers without Twilio. Connect a
            Twilio account to import and manage your Twilio numbers here too.
          </AlertDescription>
        </div>
        {canConnect ? (
          <Button
            type="button"
            size="sm"
            className="w-fit shrink-0"
            onClick={onConnect}
          >
            Connect Twilio
          </Button>
        ) : null}
      </div>
    </Alert>
  )
}
